import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';

@Component({
    selector: 'app-configuration-state-icon',
    templateUrl: './configuration-state-icon.component.html',
    standalone: false
})
export class ConfigurationStateIconComponent extends AppBaseComponent implements OnChanges {
  @Input() isConfigured: boolean;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isConfigured.previousValue !== changes.isConfigured.currentValue) {
      this.isConfigured = changes.isConfigured.currentValue;
    }
  }
}
